import { getTrueDemApi, CallDetails } from "../../model/api";
import { JwtTokenFn } from "@me8eon/authentication";

export const getCalls = async (date: string, trueDemApiTokenFn: JwtTokenFn): Promise<any> => {

    const startDate = new Date(date);
    startDate.setHours(0, 0, 0, 0);

    const endDate = new Date(date);
    endDate.setHours(23, 59, 59, 999);

    const path = `teams/calls`;

    const queryParams = {
        start: startDate.toISOString(),
        end: endDate.toISOString(),
    };

    try {
        const response = await getTrueDemApi<CallDetails[]>(
            path,
            trueDemApiTokenFn,
            queryParams
        );

        const calls = response.data;
        return calls ?? [];
    } catch (error) {
        console.error(`Error fetching calls for date ${date}:`, error);
        return [];
    }
};